import { ISelectOption } from "components/common/CustomSelect";
import { ReactComponent as Ship } from 'assets/quote/ship.svg'
import { ReactComponent as AirPlane } from 'assets/quote/airplane.svg'

const tradeTypeMenu = [
    { label: '수출', value: 'EXPORT' },
    { label: '수입', value: 'IMPORT' }
]
const transportTypeMenu = [
    { label: '해상', value: 'SEA', icon: Ship },
    { label: '항공', value: 'AIR', icon: AirPlane }
]

const shipmentModeMenu = [
    { label: 'FCL-DRY', value: 'FCL-DRY' },
    { label: 'LCL', value: 'LCL' },
    { label: 'OT', value: 'OT' },
    { label: 'FR', value: 'FR' },
]

const shipmentModeMenuSimple = [
    { label: 'FCL-DRY', value: 'FCL-DRY' },
    { label: 'LCL', value: 'LCL' },
    { label: 'OOG', value: 'OOG' },
]

const incoterms: ISelectOption[] = [
    { value: 'CIF', label: 'CIF(운임 · 보험료 포함 인도조건)', labelEn: 'CIF' },
    { value: 'EXW', label: 'EXW(공장인도조건)', labelEn: 'EXW' },
    { value: 'FCA', label: 'FCA(운송인 인도조건)', labelEn: 'FCA' },
    { value: 'FAS', label: 'FAS(선측인도조건)', labelEn: 'FAS' },
    { value: 'FOB', label: 'FOB(본선인도조건)', labelEn: 'FOB' },
    { value: 'CFR', label: 'CFR(운임포함조건)', labelEn: 'CFR' },
    { value: 'CPT', label: 'CPT(운송비지급조건)', labelEn: 'CPT' },
    { value: 'CIF', label: 'CIF(운임보험료포함조건)', labelEn: 'CIF' },
    { value: 'CIP', label: 'CIP(운송비보험료지급조건)', labelEn: 'CIP' },
    { value: 'DAP', label: 'DAP(도착지인도조건)', labelEn: 'DAP' },
    { value: 'DPU', label: 'DPU(도착지양하인도조건)', labelEn: 'DPU' },
    { value: 'DDP', label: 'DDP(관세지급인도조건)', labelEn: 'DDP' },
];

const packingUnit: ISelectOption[] = [
    { value: 'BOX', label: 'BOX', labelEn: 'BOX' },
    { value: 'PALLET', label: 'PALLET', labelEn: 'PALLET' },
    { value: 'CARTON', label: 'CARTON', labelEn: 'CARTON' },
    { value: 'BAGS', label: 'BAGS', labelEn: 'BAGS' },
    { value: 'BALES', label: 'BALES', labelEn: 'BALES' },
    { value: 'BUNDLES', label: 'BUNDLES', labelEn: 'BUNDLES' },
    { value: 'CANS', label: 'CANS', labelEn: 'CANS' },
    { value: 'CARBOYS', label: 'CARBOYS', labelEn: 'CARBOYS' },
    { value: 'CASES', label: 'CASES', labelEn: 'CASES' },
    { value: 'CRATES', label: 'CRATES', labelEn: 'CRATES' },
    { value: 'CYLINDERS', label: 'CYLINDERS', labelEn: 'CYLINDERS' },
    { value: 'DRUMS', label: 'DRUMS', labelEn: 'DRUMS' },
    { value: 'LOOSE', label: 'LOOSE', labelEn: 'LOOSE' },
    { value: 'PACKAGE', label: 'PACKAGE', labelEn: 'PACKAGE' },
    { value: 'PAILS', label: 'PAILS', labelEn: 'PAILS' },
    { value: 'PIPES', label: 'PIPES', labelEn: 'PIPES' },
    { value: 'REELS', label: 'REELS', labelEn: 'REELS' },
    { value: 'ROLLS', label: 'ROLLS', labelEn: 'ROLLS' },
    { value: 'TUBES', label: 'TUBES', labelEn: 'TUBES' },
    { value: 'WOODEN BOX', label: 'WOODEN BOX', labelEn: 'WOODEN BOX' },
    { value: 'OTHER', label: 'OTHER', labelEn: 'OTHER' },
];

const booleanSelect: ISelectOption[] = [
    { value: 'Y', label: '예', labelEn: 'Yes' },
    { value: 'N', label: '아니요', labelEn: 'No' },
]

const inOutGageSelect: ISelectOption[] = [
    { value: 'IN', label: 'IN', labelEn: 'IN' },
    { value: 'OUT', label: 'OUT', labelEn: 'OUT' },
]

const ventSelect: ISelectOption[] = [
    { value: 'Y', label: 'VENT: Open', labelEn: 'Open' },
    { value: 'N', label: 'VENT: Close', labelEn: 'Close' },
]

const currencySelect: ISelectOption[] = [
    { value: 'USD', label: '$ (USD)', labelEn: '$ (USD)' },
    { value: 'KRW', label: '₩ (KRW)', labelEn: '₩ (KRW)' },
    { value: 'EUR', label: '€ (EUR)', labelEn: '€ (EUR)' },
]

const containerSelect: ISelectOption[] = [
    { value: '20GP', label: '20GP', labelEn: '20GP', type: "FCL", require: "flexi" },
    { value: '40GP', label: '40GP', labelEn: '40GP', type: "FCL", require: "flexi" },
    { value: '40HQ', label: '40HQ', labelEn: '40HQ', type: "FCL", require: "flexi" },
    { value: '45GP', label: '45GP', labelEn: '45GP', type: "FCL", require: "flexi" },
    { value: '20OT', label: '20OT', labelEn: '20OT', type: "OT" },
    { value: '40OT', label: '40OT', labelEn: '40OT', type: "OT" },
    { value: '20RF', label: '20RF', labelEn: '20RF', type: "FCL", require: "frozen" },
    { value: '40RF', label: '40RF', labelEn: '40RF', type: "FCL", require: "frozen" },
    // { value: '20TK', label: '20TK', labelEn: '20TK', type: "FCL", require: "frozen" },
    // { value: '40TK', label: '40TK', labelEn: '40TK', type: "FCL", require: "frozen" },
]

const floatingContainerSelect: ISelectOption[] = [
    { value: "20' Dry", label: "20' Dry", labelEn: "20' Dry" },
    { value: "40' Dry", label: "40' Dry", labelEn: "40' Dry" },
    { value: "40' HC", label: "40' HC", labelEn: "40' HC" },
]

const statusSelect: ISelectOption[] = [
    { value: 'REQUEST', label: '요청', labelEn: 'REQUEST' },
    { value: 'HOLDING', label: '보류', labelEn: 'HOLDING' },
    { value: 'PENDING', label: '대기중', labelEn: 'PENDING' },
    { value: 'INPROG', label: '진행중', labelEn: 'INPROG' },
    { value: 'COMPLETE', label: '완료', labelEn: 'COMPLETE' },
    { value: 'CANCELED', label: '취소', labelEn: 'CANCELED' },
]

const quoteStatusCountSelect: ISelectOption[] = [
    { value: '10', label: '10개 보기', labelEn: '10' },
    { value: '20', label: '20개 보기', labelEn: '20' },
    { value: '30', label: '30개 보기', labelEn: '30' },
    { value: '40', label: '40개 보기', labelEn: '40' },
]


const freightMiddleCategory: ISelectOption[] = [
    { value: 'AIR', label: '항공운임', labelEn: 'AIR' },
    { value: 'SEA', label: '해상운임', labelEn: 'SEA' },
    { value: 'ETC', label: '직접입력', labelEn: 'ETC' },
    { value: 'FIX', label: '확정운임', labelEn: 'FIX' },
]

const surChargeMiddleCategory: ISelectOption[] = [
    { value: 'F.S.C', label: 'F.S.C : 유류할증료', labelEn: 'F.S.C' },
    { value: 'S.S.C ', label: 'S.S.C : 항공보안료', labelEn: 'S.S.C' },
    { value: 'F.A.F', label: 'F.A.F', labelEn: 'F.A.F' },
    { value: 'B.A.F', label: 'B.A.F', labelEn: 'B.A.F' },
    { value: 'C.A.F', label: 'C.A.F', labelEn: 'C.A.F' },
    { value: 'E.B.S', label: 'E.B.S', labelEn: 'E.B.S' },
    { value: 'C.I.C', label: 'C.I.C', labelEn: 'C.I.C' },
    { value: 'L.S.S', label: 'L.S.S(Low Sulfer Surcharge)', labelEn: 'L.S.S' },
    { value: 'ETC', label: '직접입력', labelEn: 'ETC' },
]

const additionalMiddleCategory: ISelectOption[] = [
    { value: 'AMS FEE', label: 'AMS FEE', labelEn: 'AMS FEE' },
    { value: 'ENS FEE', label: 'ENS FEE', labelEn: 'ENS FEE' },
    { value: 'T.H.C', label: 'T.H.C', labelEn: 'T.H.C' },
    { value: 'Whafrage', label: 'Whafrage', labelEn: 'Whafrage' },
    { value: 'C.F.S.Charge', label: 'C.F.S.Charge', labelEn: 'C.F.S.Charge' },
    { value: 'C.F.S Shuttle Charge', label: 'C.F.S Shuttle Charge', labelEn: 'C.F.S Shuttle Charge' },
    { value: 'Document Fee', label: 'Document Fee', labelEn: 'Document Fee' },
    { value: 'Seal Charge', label: 'Seal Charge', labelEn: 'Seal Charge' },
    { value: 'Port Facilty Security', label: 'Port Facilty Security', labelEn: 'Port Facilty Security' },
    { value: 'Port Safty Maintenance', label: 'Port Safty Maintenance', labelEn: 'Port Safty Maintenance' },
    { value: 'Charge', label: 'Charge', labelEn: 'Charge' },
    { value: 'Customs Clearance Fee', label: 'Customs Clearance Fee', labelEn: 'Customs Clearance Fee' },
    { value: 'Insurance Fee', label: 'Insurance Fee', labelEn: 'Insurance Fee' },
    { value: 'Trucking Charge', label: 'Trucking Charge', labelEn: 'Trucking Charge' },
    { value: 'ETC', label: '직접입력', labelEn: 'ETC' },
]

const convertStatus = (status: string): string => {
    const find = statusSelect.find(arr => arr.value === status)
    return find?.label || ''
}


const activeSelect: ISelectOption[] = [
    { value: 'Y', label: '활성화', labelEn: 'Yes' },
    { value: 'N', label: '비활성화', labelEn: 'No' },
]

const dateSelect: ISelectOption[] = [
    { value: 'Y', label: '출고일확정', labelEn: 'Yes' },
    { value: 'N', label: '출고일미정', labelEn: 'No' },
]

export {
    tradeTypeMenu,
    transportTypeMenu,
    shipmentModeMenu,
    incoterms,
    booleanSelect,
    containerSelect,
    packingUnit,
    ventSelect,
    currencySelect,
    statusSelect,
    quoteStatusCountSelect,
    shipmentModeMenuSimple,
    freightMiddleCategory,
    surChargeMiddleCategory,
    additionalMiddleCategory,
    convertStatus,
    inOutGageSelect,
    activeSelect,
    floatingContainerSelect,
    dateSelect
}